import { CalendarClock, CalendarDays, FolderKanban, GraduationCap } from 'lucide-react';
import type { PillField } from '@/components/common/LabeledPill';
import { formatDisplayDate } from '@/utils/date';
import type { QuestionProject } from '../types/question.types';

export const getProjectPillFields = (project: QuestionProject | undefined): PillField[] => {
  const isLoading = project === undefined;
  return [
    {
      key: 'project',
      icon: FolderKanban,
      label: 'Project',
      value: project?.name,
      isLoading,
    },
    {
      key: 'class',
      icon: GraduationCap,
      label: 'Class',
      value: project?.className ?? undefined,
      isLoading,
    },
    {
      key: 'declareDate',
      icon: CalendarDays,
      label: 'Declare Date',
      value: project === undefined ? undefined : formatDisplayDate(project.declareDate),
      isLoading,
    },
    {
      key: 'deadline',
      icon: CalendarClock,
      label: 'Project Deadline',
      value: project === undefined ? undefined : formatDisplayDate(project.deadlineDate),
      isLoading,
    },
  ];
};
